import { MenuItemType } from "./menuData";

// Recursively filter menu items and their children
export const filterMenu = (menu: MenuItemType[], searchTerm: string): MenuItemType[] => {
    if (!searchTerm) return menu;

    return menu
        .map((item) => {
            const filteredChildren = item.children ? filterMenu(item.children, searchTerm) : undefined;

            if (
                item.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (filteredChildren && filteredChildren.length > 0)
            ) {
                return {
                    ...item,
                    children: filteredChildren,
                };
            }

            return null;
        })
        .filter(Boolean) as MenuItemType[];
};